import axios from 'axios';
import { config } from '../assets/config/config';

const apiUrl = config.api.url;

const getPaymentGateway = () => {
  return axios.get(`${apiUrl}/v1/users/me/payment-gateway`);
};

const createCheckoutSession = (planType, opts = {}) => {
  const payload = { planType };
  if (opts.country) payload.country = opts.country;
  if (opts.referralCode) payload.referralCode = opts.referralCode;
  return axios.post(`${apiUrl}/v1/stripe/create-checkout-session`, payload);
};

const createCoffeeSession = (coffeeCount, supportMessage = '') => {
  return axios.post(`${apiUrl}/v1/stripe/create-coffee-session`, {
    coffeeCount,
    supportMessage,
  });
};

const createCreditPackSession = (pack, opts = {}) => {
  const payload = { pack };
  if (opts.country) payload.country = opts.country;
  if (opts.referralCode) payload.referralCode = opts.referralCode;
  return axios.post(`${apiUrl}/v1/stripe/create-credit-pack-session`, payload);
};

const getCheckoutSession = (sessionId) =>
  axios.get(`${apiUrl}/v1/stripe/checkout-session/${encodeURIComponent(sessionId)}`);

const cancelStripeSubscription = (unsubscribeReason = null, unsubscribeComments = null) => {
  const payload = {};
  if (unsubscribeReason !== null) payload.unsubscribeReason = unsubscribeReason;
  if (unsubscribeComments !== null) payload.unsubscribeComments = unsubscribeComments;
  return axios.post(`${apiUrl}/v1/stripe/cancel-subscription`, payload);
};

const pauseStripeSubscription = () => {
  return axios.post(`${apiUrl}/v1/stripe/pause-subscription`, {});
};

const resumeStripeSubscription = () => {
  return axios.post(`${apiUrl}/v1/stripe/resume-subscription`, {});
};

export const stripeCheckoutService = {
  getPaymentGateway,
  createCheckoutSession,
  createCreditPackSession,
  createCoffeeSession,
  getCheckoutSession,
  cancelStripeSubscription,
  pauseStripeSubscription,
  resumeStripeSubscription,
};
